import _ from 'lodash';
import { getPageInitDataByKey } from '../';

export const getCurrentUser = (): { email: string } => {
    const sessionData = getPageInitDataByKey('session', {});

    return _.get(sessionData, 'user', {});
};
